import React from 'react';
import IconCheckSolidRounded from '@/assets/icons/icon_check-cr--solid--m.svg';
import IconGiftSolid from '@/assets/icons/icon_gift--solid--s.svg';
import IconPlusSolidRounded from '@/assets/icons/icon_plus-cr--solid--m.svg';
import IconArrowDown from '@/assets/icons/arrow_down.svg';
import IconCollection from '@/assets/icons/collection_icon.svg';
import IconDrop from '@/assets/icons/drops_icon.svg';
import IconClosePage from '@/assets/icons/icon_close_page.svg';
import IconClosePopup from '@/assets/icons/icon_close_popup.svg';
import IconChevronLeft from '@/assets/icons/icon_chevron-left--line--m.svg';
import IconChevronRight from '@/assets/icons/icon_chevron-right--line--m.svg';
import IconChevronDown from '@/assets/icons/icon_chevron-down--line--m.svg';
import IconChevronUp from '@/assets/icons/icon_chevron-up--line--m.svg';
import IconFlagRu from '@/assets/icons/flags/flag-icon_ru.svg';
import IconFlagEn from '@/assets/icons/flags/flag-icon_en.svg';
import IconExternalLink from '@/assets/icons/external_link.svg';

export type IconComponentsObject = Record<
  | 'icon_check_cr_solid'
  | 'icon_close_page'
  | 'icon_close_popup'
  | 'icon_chevron_down'
  | 'icon_chevron_up'
  | 'icon_chevron_left'
  | 'icon_chevron_right'
  | 'icon_plus_cr_solid'
  | 'arrow_down'
  | 'icon_gift_solid'
  | 'collection_icon'
  | 'flag_ru'
  | 'flag_en'
  | 'drop_icon'
  | 'external_link',
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
>;

export const iconComponents: IconComponentsObject = {
  icon_close_popup: IconClosePopup,
  icon_check_cr_solid: IconCheckSolidRounded,
  icon_gift_solid: IconGiftSolid,
  icon_plus_cr_solid: IconPlusSolidRounded,
  arrow_down: IconArrowDown,
  collection_icon: IconCollection,
  drop_icon: IconDrop,
  icon_close_page: IconClosePage,
  icon_chevron_down: IconChevronDown,
  icon_chevron_up: IconChevronUp,
  icon_chevron_left: IconChevronLeft,
  icon_chevron_right: IconChevronRight,
  flag_en: IconFlagEn,
  flag_ru: IconFlagRu,
  external_link: IconExternalLink,
};
